module.exports = __webpack_public_path__ + "images/emoji/currency_exchange.89caadd00c82f7dd9b90.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/currency_exchange.png
// module id = m8H9
// module chunks = 2